<template>
  <div
    class="grid-col-6 tablet:grid-col-2"
    :class="[data.fields.styleInstructions, getGrid4]"
  >
    <span
      class="display-flex flex-column height-full padding-2 text-center text-white text-no-underline hover:text-underline link-text"
      :class="data.fields.svgIconCode"
    >
      <span class="svg-lg" v-if="data.fields.svgIconCode === 'email'">
        <!-- pooja, 12-mar-26, removed homeonlyclass not in use and getting console errors -->
        <svg
          width="24"
          height="24"
          viewBox="0 0 512 512"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
          ></path>
        </svg>
      </span>

      <span class="svg-lg" v-if="data.fields.svgIconCode === 'chat'">
        <svg
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 60.02 60.02"
          style="enable-background: new 0 0 60.02 60.02"
          xml:space="preserve"
          fill="#EEEEEE"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <g>
            <path
              d="M59.889,47.515L56.05,35.997c2.056-3.615,3.14-7.717,3.14-11.893C59.19,10.819,48.38,0.01,35.095,0.01
          c-8.242,0-15.823,4.223-20.219,11.007c3.089-1.291,6.477-2.007,10.029-2.007C39.294,9.01,51,20.716,51,35.105
          c0,3.996-0.905,7.783-2.518,11.172l10.263,2.701C58.83,48.999,58.915,49.01,59,49.01c0.004,0,0.007,0,0.011,0
          c0.542-0.01,1.009-0.444,1.009-1C60.02,47.83,59.973,47.661,59.889,47.515z"
            />
            <path
              d="M24.905,11.01c-13.286,0-24.095,10.809-24.095,24.095c0,4.176,1.084,8.277,3.14,11.893L0.051,58.694
          c-0.116,0.349-0.032,0.732,0.219,1C0.462,59.899,0.728,60.01,1,60.01c0.085,0,0.17-0.011,0.254-0.033l12.788-3.365
          c3.349,1.694,7.096,2.588,10.863,2.588C38.191,59.199,49,48.391,49,35.105S38.191,11.01,24.905,11.01z M20,27.01h11
          c0.552,0,1,0.447,1,1s-0.448,1-1,1H20c-0.552,0-1-0.447-1-1S19.448,27.01,20,27.01z M36,43.01H15c-0.552,0-1-0.447-1-1s0.448-1,1-1
          h21c0.552,0,1,0.447,1,1S36.552,43.01,36,43.01z M36,36.01H15c-0.552,0-1-0.447-1-1s0.448-1,1-1h21c0.552,0,1,0.447,1,1
          S36.552,36.01,36,36.01z"
            />
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      </span>
      <span class="svg-lg" v-if="data.fields.svgIconCode === 'call'">
        <svg
          width="24"
          height="24"
          viewBox="0 0 512 512"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
          ></path>
        </svg>
      </span>
      <span class="svg-lg" v-if="data.fields.svgIconCode === 'skype'">
        <svg
          width="24"
          height="24"
          viewBox="0 0 448 512"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
          ></path>
        </svg>
      </span>
      <span
        class="svg-lg"
        :class="data.fields.svgIconCode"
        v-if="data.fields.svgIconCode === 'skype-blue'"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 448 512"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
          ></path>
        </svg>
      </span>
      <span
        class="svg-lg"
        :class="data.fields.svgIconCode"
        v-if="data.fields.svgIconCode === 'person and shield'"
        ><svg
          width="24"
          height="24"
          viewBox="0 0 640 512"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
          ></path></svg
      ></span>
      <span
        class="svg-lg"
        :class="data.fields.svgIconCode"
        v-if="data.fields.svgIconCode === 'ribbon'"
        ><svg
          width="24"
          height="24"
          viewBox="0 0 384 512"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
          ></path></svg
      ></span>

      <span
        class="svg-lg"
        :class="data.fields.svgIconCode"
        v-if="data.fields.svgIconCode === 'question'"
        ><svg
          width="24"
          height="24"
          viewBox="0 0 512 512"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
          ></path></svg
      ></span>

      <span
        class="svg-lg"
        :class="data.fields.svgIconCode"
        v-if="data.fields.svgIconCode === 'folded page'"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 384 512"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
          ></path>
        </svg>
      </span>
      <span
        class="padding-right-1"
        v-if="data.fields.svgIconCode === 'doc-upload'"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 384 512"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
          ></path>
        </svg>
      </span>

      <span
        class="svg-lg"
        :class="data.fields.svgIconCode"
        v-if="data.fields.svgIconCode === 'webcall'"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 384 448"
          xml:space="preserve"
          fill="#EEEEEE"
          aria-hidden="true"
          role="presentation"
          focusable="false"
        >
          <path
            d="M0 0 C4.31006402 4.31611748 8.09158339 8.93508602 11.78125 13.78515625 C12.76158203 15.04199219 12.76158203 15.04199219 13.76171875 16.32421875 C24.10638409 29.99321767 31.71163401 44.80206966 37.78125 60.78515625 C38.02713867 61.43162109 38.27302734 62.07808594 38.52636719 62.74414062 C45.86874437 82.45648565 50.17484448 103.77136265 51.23046875 124.7578125 C51.26728256 125.45430908 51.30409637 126.15080566 51.34202576 126.8684082 C51.52369013 130.35853422 51.67728831 133.84612194 51.78393555 137.33935547 C51.84234619 138.61955566 51.90075684 139.89975586 51.9609375 141.21875 C52.01870361 142.9366272 52.01870361 142.9366272 52.07763672 144.68920898 C52.98090143 148.66363641 54.73213484 150.16888446 57.78125 152.78515625 C66.26373665 160.96265462 71.34630526 171.9001292 74.84375 183.03515625 C76.03723257 186.57354291 76.79446265 188.26612803 80.15625 189.97265625 C81.05730469 190.37677734 81.05730469 190.37677734 81.9765625 190.7890625 C87.18590805 193.66435063 89.88327442 199.40445553 91.65625 204.84765625 C93.99088502 213.97774677 92.45788218 221.89338019 87.96875 230.09765625 C84.54801703 234.30027104 81.47686388 237.27944685 76.21875 238.84765625 C71.49256034 241.51150861 70.91599547 244.57113672 69.08203125 249.5234375 C63.09540916 264.53493734 51.41527836 276.19243487 36.71875 282.59765625 C28.95427651 285.61993531 22.10519796 287.08784527 13.78125 286.78515625 C13.64589844 287.39359375 13.51054687 288.00203125 13.37109375 288.62890625 C6.1518639 318.02457269 -13.44883418 342.55393919 -38.53515625 358.953125 C-60.65864089 372.20670734 -83.64781276 376.50002548 -109.2109375 376.25170898 C-112.47967878 376.22255879 -115.74680681 376.23119626 -119.015625 376.24414062 C-154.2465402 376.21017012 -184.61496988 364.32852861 -209.79589844 339.27392578 C-223.52677905 324.90691995 -232.35087562 306.56891056 -238.21875 287.78515625 C-239.30671875 287.62660156 -240.3946875 287.46804688 -241.515625 287.3046875 C-259.73545902 284.48931114 -275.10428049 277.90844203 -286.3828125 262.65625 C-300.3292404 240.84641063 -306.10798043 214.48908075 -301.19287109 188.84326172 C-298.08172523 175.33813315 -291.33986212 159.94669654 -280.078125 151.40234375 C-275.41016463 146.74308956 -276.23853185 140.23150736 -276.09375 134.03515625 C-275.98041884 131.32323542 -275.84148006 128.612885 -275.69921875 125.90234375 C-275.6651442 125.21923126 -275.63106964 124.53611877 -275.59596252 123.83230591 C-274.65277378 106.22341514 -271.11161115 88.70047624 -266.21875 71.78515625 C-266.00524902 71.0389502 -265.79174805 70.29274414 -265.57177734 69.52392578 C-253.89343185 29.60474183 -228.20372485 -5.36844406 -191.73828125 -25.828125 C-129.4710338 -59.45271012 -50.99667335 -48.4217705 0 0 Z M-205.21875 10.78515625 C-206.09144531 11.57535156 -206.96414062 12.36554687 -207.86328125 13.1796875 C-240.03590419 43.7310129 -253.04755915 91.6853328 -254.21875 134.78515625 C-251.22322544 134.32661256 -251.22322544 134.32661256 -248.21875 132.78515625 C-247.20725219 130.25008987 -246.67274716 128.30023831 -246.21875 125.66015625 C-245.90716692 124.19761667 -245.58792403 122.7366916 -245.26171875 121.27734375 C-245.01301025 120.15537598 -245.01301025 120.15537598 -244.75927734 119.01074219 C-240.79740641 102.69799811 -232.2566986 87.32050098 -221.21875 74.78515625 C-220.53296875 73.96789062 -219.8471875 73.150625 -219.140625 72.30859375 C-200.80274898 51.00235651 -174.36222529 37.19670729 -147.21875 30.78515625 C-146.53925293 30.62144531 -145.85975586 30.45773438 -145.15966797 30.2890625 C-122.37557432 25.08618384 -95.71249898 25.77640338 -73.21875 31.78515625 C-72.35427246 32.01589844 -71.48979492 32.24664062 -70.59912109 32.484375 C-37.37480106 41.74090197 -7.36346955 62.47239171 9.78125 92.78515625 C16.00955164 104.36098959 20.49985972 116.01387648 22.65625 129.03515625 C23.0275 130.27265625 23.39875 131.51015625 23.78125 132.78515625 C26.78621098 134.06833709 26.78621098 134.06833709 29.78125 134.78515625 C29.01999587 106.42843981 22.61571258 78.1557443 9.78125 52.78515625 C9.25942139 51.7497168 9.25942139 51.7497168 8.72705078 50.69335938 C3.4863963 40.475882 -2.86765583 31.57936716 -10.21875 22.78515625 C-10.65171387 22.252854 -11.08467773 21.72055176 -11.53076172 21.17211914 C-15.07499722 16.83408762 -18.94599215 13.37397868 -23.21875 9.78515625 C-23.99863281 9.09421875 -24.77851563 8.40328125 -25.58203125 7.69140625 C-75.52502123 -35.35505552 -157.0113887 -33.55142328 -205.21875 10.78515625 Z M-202.21875 85.78515625 C-217.48966486 103.21812314 -226.32210684 123.47167196 -226.421875 146.78515625 C-226.42884399 147.87267181 -226.43581299 148.96018738 -226.44299316 150.08065796 C-226.46053184 153.64886284 -226.46673273 157.21690982 -226.46875 160.78515625 C-226.46975708 162.0092218 -226.47076416 163.23328735 -226.47180176 164.4944458 C-228.06911896 251.71186522 -228.06911896 251.71186522 -190.21875 326.78515625 C-179.55316305 337.13966358 -167.06770017 344.44288663 -153.03125 349.22265625 C-152.00040283 349.57505371 -152.00040283 349.57505371 -150.94873047 349.93457031 C-138.99419726 353.71322164 -126.87766119 354.13307362 -114.4543457 354.10083008 C-111.92029579 354.09767374 -109.38742202 354.12120666 -106.85351562 354.14648438 C-78.10508464 354.26032881 -52.80508484 344.80399462 -31.90625 324.84765625 C-15.58381487 307.63738992 -6.93310545 286.0799978 -4.21875 262.78515625 C-9.56462742 263.81401366 -14.8844677 264.92055049 -20.1875 266.15234375 C-38.64428512 270.43094927 -57.15889864 274.17992128 -76.09545898 275.4128418 C-86.54086613 275.97206228 -86.54086613 275.97206228 -94.70703125 282.09765625 C-98.3417446 286.15501069 -102.72835003 286.66082674 -107.96484375 287.09765625 C-115.7021375 287.4248416 -122.5615752 287.13792439 -129.21875 282.78515625 C-129.80140625 282.41132813 -130.3840625 282.0375 -130.984375 281.65234375 C-135.0337431 278.68411762 -136.77385089 275.52121445 -138.21875 270.78515625 C-138.90912231 264.57180546 -138.10551356 259.81508556 -134.21875 254.78515625 C-126.79814359 248.31003251 -119.07219381 246.294161 -109.35546875 246.46484375 C-103.36597532 247.07647322 -97.46175845 248.76231893 -92.93798828 252.84204102 C-85.57067801 258.10657885 -72.37121323 254.37991646 -63.90625 253.09765625 C-62.69420898 252.91759033 -61.48216797 252.73752441 -60.23339844 252.55200195 C-40.08783608 249.47121011 -20.68377364 244.80147586 -1.21875 238.78515625 C0.91399817 214.87871309 2.11780133 191.00636285 2.203125 167.00402832 C2.21345851 164.37923717 2.23043888 161.75446292 2.25439453 159.12976074 C2.49634676 129.00574806 -3.66626408 104.95908942 -25.21875 82.6953125 C-49.20465959 58.9082251 -81.22164584 48.52234966 -114.48876953 48.53637695 C-147.41707657 48.91533329 -179.24602453 62.01548857 -202.21875 85.78515625 Z M-264.90625 165.97265625 C-278.46434019 180.5220219 -281.02826344 196.95488858 -280.38916016 216.01464844 C-279.50665602 230.3622944 -273.30424426 246.35031165 -262.4921875 256.13671875 C-256.30125391 260.62567747 -249.82533541 263.8032973 -242.21875 264.78515625 C-242.32832031 263.60050781 -242.43789062 262.41585937 -242.55078125 261.1953125 C-245.7025354 226.43431713 -247.81917908 191.65884539 -249.21875 156.78515625 C-254.75237872 156.78515625 -261.01886421 162.31497962 -264.90625 165.97265625 Z M24.78125 156.78515625 C24.38724386 164.82649222 23.9958817 172.86795086 23.60779572 180.90957451 C23.42746679 184.64453235 23.24626371 188.37944331 23.06298828 192.11425781 C22.88579997 195.72571037 22.71100531 199.33727189 22.53779602 202.94891739 C22.471658 204.31949029 22.40469071 205.69002347 22.33683777 207.06051254 C21.96208762 214.64148673 21.67629723 222.19426663 21.78125 229.78515625 C30.77905783 226.24056529 39.3927635 222.11836031 47.98339844 217.69042969 C49.69924801 216.82644677 51.44696043 216.02662907 53.1953125 215.23046875 C56.08518035 213.99642223 56.08518035 213.99642223 56.78125 210.78515625 C56.88712137 193.88808572 52.23559918 178.33763226 40.40625 165.84765625 C36.37486793 162.04446561 30.64348453 156.78515625 24.78125 156.78515625 Z M40.79296875 244.90234375 C39.77654297 245.34449219 38.76011719 245.78664063 37.71289062 246.2421875 C36.64232422 246.71011719 35.57175781 247.17804688 34.46875 247.66015625 C32.88030273 248.35044922 32.88030273 248.35044922 31.25976562 249.0546875 C27.01360141 250.90430718 27.01360141 250.90430718 22.78125 252.78515625 C22.02271729 253.11515625 21.26418457 253.44515625 20.48266602 253.78515625 C19.92119873 254.11515625 19.35973145 254.44515625 18.78125 254.78515625 C18.07948412 257.20195332 18.07948412 257.20195332 18.03125 259.91015625 C17.97453125 260.82023437 17.9178125 261.7303125 17.859375 262.66796875 C17.83359375 263.36664063 17.8078125 264.0653125 17.78125 264.78515625 C30.37957376 262.39147473 38.1823534 257.20758301 45.78125 246.78515625 C46.52913833 244.62652 46.52913833 244.62652 46.78125 242.78515625 C44.71988317 242.78515625 42.63679121 244.09946329 40.79296875 244.90234375 Z "
            transform="translate(302.21875,45.21484375)"
          />
        </svg>
      </span>

      <span
        class="svg-lg"
        :class="data.fields.svgIconCode"
        v-if="data.fields.svgIconCode === 'AI'"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="82"
          height="100"
          viewBox="0 0 82 100"
        >
          <image
            xlink:href="data:image/png;base64,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"
            x="0"
            y="0"
            width="82"
            height="100"
          />
        </svg>
      </span>
      <rich-text-renderer :data="data.fields.ctaLink"></rich-text-renderer>
    </span>
  </div>
</template>
<script>
export default {
  name: "independent-cta",
  props: ["data"],
  computed: {
    getGrid4() {
      return this.data.fields.styleInstructions === "grid-cta-4"
        ? "tablet:grid-col-2"
        : "";
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep a.usa-link {
  text-decoration: none;
  font-weight: bold;
  span {
    display: none;
  }
  &:hover {
    span {
      display: none;
    }
  }
}
.skype-blue {
  svg {
    fill: #0071bc;
  }
}
.cta-icon-center {
  margin: 0 auto;
  ::v-deep p {
    margin: 0;
  }
}
::v-deep .link-text {
  p {
    margin: 0 !important;
  }
}
.padding-right-1 {
  svg {
    color: #0071bc;
  }
}
.doc-upload {
  display: -webkit-box;
  padding: 10px 0 0;
  white-space: nowrap;
}

.btn-link-text {
  ::v-deep .text-white {
    color: #232323 !important;
    font-weight: 600;
    text-decoration: none;
  }
}
::v-deep .display-flex {
  align-items: center;
}
</style>
